export class OrganismsRegistrationRequest {
  public idUsuario: number;
  public versionAplicativo: string;
  public uuid: string;
  public email: string;
  public password: string;
  public cuit: string;
  public razonSocial: string;
  public plataforma: string;
  public version: string;
  public descripcion: string;
  public recaptchaClientToken: string;
}
